<template>
  <div class="site-side" v-show="isShowNav">
    <a class="logo" target="_blank" href="/">
      <img src="../../assets/img/logo-new.png" alt />
    </a>

    <el-scrollbar>
      <div class="navs">
        <div class="navs-view">
          <div class="nav-group-item" :class="{
            active: (currentNav === 'Home') | (currentNav === 'userHome'),
          }">
            <div class="nav-group-title" @click="
              goPage({ name: userInfo.identity === 0 ? 'userHome' : 'Home' })
              ">
              <span class="nav-icon icon-home"></span>
              {{ $t("index3") }}
            </div>
          </div>
          <template v-for="(item, key) in navs">
            <div class="nav-group-item" v-if="item.isShow" :key="key" :class="{
              active: currentNav === item.name,
              newMsg: item.name === 'message' && userInfo.is_unread_message,
            }">
              <div class="nav-group-title" @click="openMenu(item, key)">
                <span class="nav-icon" :class="`icon-${item.icon}`"></span>
                {{ item.title }}
                <i v-if="item.navChild && item.navChild.length > 0" class="arrow"
                  :class="item.isOpen ? 'arrow-up' : 'arrow-down'"></i>
              </div>
              <div class="nav-group-view" v-if="item.navChild && item.navChild.length > 0" v-show="item.isOpen">
                <template v-for="(childItem, childKey) in item.navChild">
                  <div
                    class="nav-section-title"
                    v-if="childItem.isShow && childItem.isGroupTitle"
                    :key="`section-${childKey}`"
                  >
                    {{ childItem.title }}
                  </div>
                  <div
                    class="nav-item"
                    v-else-if="childItem.isShow"
                    :class="{ active: currentNav === childItem.name }"
                    :key="childKey"
                  >
                    <div class="nav-item-link" @click="goPage(childItem)">
                      <span>{{ childItem.title }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-scrollbar>

    <div class="user-info" v-if="userInfo">
      <div class="user">
        <div class="avatar">
          <img src="" alt="" />
        </div>
        <div class="info">
          <span class="nickname">{{ userInfo.username }}</span>
          <span class="user-id">
            {{ userInfo.identity > 0 ? $t('index22') : $t('user5') }}:{{ userInfo.account_id }}
          </span>
        </div>
      </div>
      <!-- <span class="info-tag" :class="`status${userInfo.auth_status}`"
        @click="$router.push({ name: userInfo.identity === 0 ? 'userInfo' : 'proxyInfo' })">{{ showAuthStatus }}</span> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import navProxy from './navProxy'
import navUser from './navUser'
import { userAuthStatusText } from '@utils/global'
import { enterTradeSystem } from '@utils/tradeSystem'

export default {
  name: 'SiteFooter',
  data () {
    return {
      navProxy,
      navUser,
      currentNav: '',
      navs: []
    }
  },
  created () {
    this.setNavs()
  },
  watch: {
    userInfo () {
      this.setNavs()
    },
    $route () {
      this.initNavs()
    }
  },
  methods: {
    openMenu (item) {
      if (item.externalAction === 'tradeSystem') {
        enterTradeSystem(this.userInfo && this.userInfo.account_no)
        return
      }
      this.navs.map((i) => {
        if (i.icon !== item.icon) {
          i.isOpen = false
        }
        return i
      })
      if (item.navChild && item.navChild.length > 0) {
        item.isOpen = !item.isOpen
      } else {
        if (this.device === 'mobile') {
          this.$store.commit('SET_IS_SHOW_NAV', false)
        }
        this.$router.push({ name: item.name })
      }
    },
    goPage (item) {
      if (item.externalAction === 'tradeSystem') {
        enterTradeSystem(this.userInfo && this.userInfo.account_no)
        return
      }
      if (this.device === 'mobile') {
        this.$store.commit('SET_IS_SHOW_NAV', false)
      }
      this.$router.push({ name: item.name })
    },
    initNavs () {
      const brs = []
      this.currentNav = this.$route.name || ''
      if (['Home', 'userHome'].includes(this.currentNav)) {
        brs.push({ title: this.$t('index3') })
      }
      this.navs.map((item) => {
        if (item.name === this.currentNav) {
          brs.push(item)
        }
        item.navChild &&
          item.navChild.map((itemChild) => {
            if (itemChild.name === this.currentNav) {
              brs.push(item)
              brs.push(itemChild)
            }
            if (this.$route.name === itemChild.name) {
              item.isOpen = true
            }
          })
      })
      this.$store.commit('SET_BREADCRUMBS', brs)
    },
    setNavs () {
      if (!this.userInfo) {
        this.navs = []
        return
      }
      if (this.userInfo.identity === 0) {
        // 普通交易用户及自动升级后的推广用户始终使用交易用户菜单。
        // promotion_level 仅决定代理等级。
        this.navs = JSON.parse(JSON.stringify(this.navUser))
      } else if ([1, 2, 3].includes(this.userInfo.identity)) {
        // identity=1 为主代理。旧 identity=2/3 账号仅做存量兼容，
        // 不提供手工创建下级代理/客户入口。
        this.navs = JSON.parse(JSON.stringify(this.navProxy)).map(item => {
          if (item.icon === 'audit') {
            item.isShow = this.userInfo.identity === 1
          }
          return item
        })
      } else {
        this.navs = []
      }
      this.initNavs()
    }
  },
  computed: {
    showAuthStatus () {
      return userAuthStatusText[this.userInfo.auth_status]
    },
    ...mapState(['userInfo', 'isShowNav', 'device'])
  }
}
</script>

<style scoped lang="scss">
.site-side {
  position: fixed;
  height: 100vh;
  top: 0px;
  max-height: calc(100% - 0px);
  transform: translateX(0%);
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  left: 0;
  max-width: 100%;
  overflow: hidden;
  pointer-events: auto;
  top: 0;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  transition-property: transform, visibility, width;
  width: 260px;
  background: url("../../assets/img/menu-bg.png") no-repeat top center / cover;
  font-family: Arial;

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 110px;
    width: 260px;
    flex: 0 0 110px;

    img {
      width: 150px;
    }
  }

  .user-info {
    height: 110px;
    flex: 0 0 110px;
    padding-top: 15px;
    padding-left: 43px;

    .user {
      display: flex;

      .avatar {
        background: url("../../assets/img/avatar-bg.png") no-repeat center / 100% 100%;
        width: 44px;
        height: 44px;
        flex: 0 0 44px;
        margin-right: 14px;

        img {}
      }

      .info {
        flex: 1;

        .nickname {
          font-size: 16px;
          font-weight: 400;
          color: #00cbfa;
          display: block;
          white-space: nowrap;
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .user-id {
          font-size: 12px;
          display: block;
          font-family: Arial;
          font-weight: 400;
          color: #96dcf0;
        }
      }
    }

    .info-tag {
      font-size: 12px;
      text-align: center;
      line-height: 21px;
      display: block;
      width: 164px;
      height: 21px;
      margin-top: 11px;
      cursor: pointer;

      &.status0,
      &.status1 {
        color: #ffe9f0;
        background: url("../../assets/img/status-bg1.png") no-repeat center / 100% 100%;
      }

      &.status2 {
        color: #c1f3ff;
        background: url("../../assets/img/status-bg2.png") no-repeat center / 100% 100%;
      }

      &.status3 {
        color: #ffeeb1;
        background: url("../../assets/img/status-bg3.png") no-repeat center / 100% 100%;
      }
    }
  }

  ::v-deep .el-scrollbar {
    height: 100%;
    flex: 1;
  }

  .navs {
    .navs-view {
      overflow-y: auto;
      height: 100%;
    }

    .nav-group-item {
      position: relative;

      &::before,
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
      }

      &::before {
        width: 240px;
        height: 1px;
        background-color: rgb(#01b2f5, 0.2);
        left: 0;
      }

      &::after {
        width: 11px;
        height: 1px;
        background-color: rgb(#01b2f5, 0.44);
        right: 3px;
      }

      &.newMsg {
        .nav-group-title {
          &::after {
            content: '';
            width: 8px;
            height: 8px;
            background: red;
            display: inline-block;
            border-radius: 6px;
            margin-left: 6px;
          }
        }
      }

      .nav-group-title {
        height: 50px;
        line-height: 50px;
        padding-left: 54px;
        font-size: 14px;
        font-weight: bold;
        color: #d4f9ff;
        letter-spacing: 0;
        display: block;
        cursor: pointer;
        position: relative;

        .icon-img {
          position: absolute;
          left: 12px;
          top: 17px;
        }

        .arrow {
          position: absolute;
          right: 15px;
          top: 15px;
          width: 30px;
          height: 20px;
          background: url("../../assets/img/nsj.png") no-repeat center / 100%;

          &.arrow-up {
            transform: rotate(-90deg);
          }
        }
      }

      .nav-group-view {
        background: url("../../assets/img/menu-child-bg.png") repeat right / 100%;
      }
    }

    .nav-section-title {
      min-height: 36px;
      margin: 8px 16px 4px 28px;
      padding: 8px 10px 7px 12px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid rgba(0, 204, 255, 0.48);
      border-left: 3px solid #00ccff;
      background: linear-gradient(90deg, rgba(0, 204, 255, 0.16), rgba(0, 99, 130, 0.06));
      box-shadow: inset 0 0 10px rgba(0, 204, 255, 0.08);
      color: #00cbfa;
      font-size: 13px;
      line-height: 18px;
      font-weight: bold;
      word-break: break-word;
    }

    .nav-item {
      position: relative;

      .icon-img {
        position: absolute;
        left: 12px;
        top: 17px;
      }

      .nav-item-link {
        display: block;
        height: 40px;
        line-height: 40px;
        padding-left: 58px;
        cursor: pointer;
        position: relative;

        span {
          font-size: 14px;
          color: #d4f9ff;
        }

        &::before {
          content: "";
          position: absolute;
          width: 20px;
          height: 20px;
          top: 8.5px;
          left: 36px;
          background: url("../../assets/img/menu-dot.png") no-repeat center / 100% 100%;
        }
      }
    }

    .active {

      a,
      .nav-item-link,
      .nav-group-title {
        color: #fff !important;
        background: url("../../assets/img/menu-select.png") no-repeat left center / 270px 100px;

        span {
          color: #fff !important;
        }
      }

      .nav-item-link {
        background: url("../../assets/img/menu-select.png") no-repeat left center / 270px 80px;
      }
    }
  }
}

.nav-icon {
  width: 32px;
  height: 50px;
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  left: 20px;

  &::before {
    content: "";
    display: block;
    width: 32px;
    height: 36px;
  }

  &.icon-home {
    &::before {
      background: url("../../assets/img/home.png") no-repeat center / 100% auto;
    }
  }

  &.icon-dividend {
    &::before {
      background: url("../../assets/img/use.png") no-repeat center / 100% auto;
    }
  }

  &.icon-trade {
    &::before {
      background: url("../../assets/img/trade.png") no-repeat center / 100% auto;
    }
  }

  &.icon-fund {
    &::before {
      background: url("../../assets/img/fond.png") no-repeat center / 100% auto;
    }
  }

  &.icon-audit {
    &::before {
      background: url("../../assets/img/audit.png") no-repeat center / 100% auto;
    }
  }

  &.icon-sub {
    &::before {
      background: url("../../assets/img/sub.png") no-repeat center / 100% auto;
    }
  }

  &.icon-bonus-growth {
    &::before {
      background: url("../../assets/img/sub.png") no-repeat center / 100% auto;
    }
  }

  &.icon-bonus-risk {
    &::before {
      background: url("../../assets/img/audit.png") no-repeat center / 100% auto;
    }
  }

  &.icon-use {
    &::before {
      background: url("../../assets/img/use.png") no-repeat center / 100% auto;
    }
  }

  &.icon-money {
    &::before {
      background: url("../../assets/img/money.png") no-repeat center / 100% auto;
    }
  }

  &.icon-my {
    &::before {
      background: url("../../assets/img/my.png") no-repeat center / 100% auto;
    }
  }

  &.icon-not {
    &::before {
      background: url("../../assets/img/not.png") no-repeat center / 100% auto;
    }
  }

  &.icon-down {
    &::before {
      background: url("../../assets/img/icon-down-.png") no-repeat center / 15.5px auto;
    }
  }
}

.active {
  .nav-icon {
    &.icon-home {
      &::before {
        background: url("../../assets/img/home-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-trade {
      &::before {
        background: url("../../assets/img/trade-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-fund {
      &::before {
        background: url("../../assets/img/fond-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-audit {
      &::before {
        background: url("../../assets/img/audit-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-sub {
      &::before {
        background: url("../../assets/img/sub-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-bonus-growth {
      &::before {
        background: url("../../assets/img/sub-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-bonus-risk {
      &::before {
        background: url("../../assets/img/audit-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-use {
      &::before {
        background: url("../../assets/img/use-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-money {
      &::before {
        background: url("../../assets/img/money-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-my {
      &::before {
        background: url("../../assets/img/my-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-not {
      &::before {
        background: url("../../assets/img/not-.png") no-repeat center / 100% auto;
      }
    }

    &.icon-down {
      &::before {
        background: url("../../assets/img/icon-down.png") no-repeat center / 100% auto;
      }
    }
  }
}

@media only screen and (max-width: 755px) {
  .site-side {
    z-index: 1000;
    background: #16303d;
    width: 360px;

    .logo {
      height: 900px;
      width: 360px;
      flex: 0 0 180px;

      img {
        width: 150px;
      }
    }

    .user-info {
      height: 210px;
      flex: 0 0 210px;
      padding-top: 15px;
      padding-left: 43px;

      .user {
        display: flex;

        .avatar {
          background: url("../../assets/img/avatar-bg.png") no-repeat center / 100% 100%;
          width: 84px;
          height: 84px;
          flex: 0 0 84px;
          margin-right: 14px;

          img {}
        }

        .info {
          flex: 1;
          padding-top: 12px;

          .nickname {
            font-size: 20px;
            font-weight: 400;
            color: #00cbfa;
            display: block;
            white-space: nowrap;
            width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .user-id {
            font-size: 16px;
            display: block;
            font-family: Arial;
            font-weight: 400;
            color: #96dcf0;
          }
        }
      }

      .info-tag {
        font-size: 18px;
        text-align: center;
        line-height: 41px;
        display: block;
        width: 264px;
        height: 41px;
        margin-top: 11px;
        cursor: pointer;
      }
    }

    ::v-deep .el-scrollbar {
      height: 100%;
      flex: 1;
    }

    .navs {
      .navs-view {
        overflow-y: auto;
        height: 100%;
      }

      .nav-group-item {
        position: relative;

        &::before,
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
        }

        &::before {
          width: 330px;
          height: 1px;
          background-color: rgb(#01b2f5, 0.2);
          left: 0;
        }

        &::after {
          width: 11px;
          height: 1px;
          background-color: rgb(#01b2f5, 0.44);
          right: 3px;
        }

        .nav-group-title {
          height: 70px;
          line-height: 70px;
          font-size: 20px;
          padding-left: 70px;

          .icon-img {
            position: absolute;
            left: 12px;
            top: 17px;
          }

          .arrow {
            position: absolute;
            right: 15px;
            top: 15px;
            width: 30px;
            height: 20px;
            background: url("../../assets/img/nsj.png") no-repeat center / 100%;

            &.arrow-up {
              transform: rotate(-90deg);
            }
          }
        }

        .nav-group-view {
          background: url("../../assets/img/menu-child-bg.png") repeat right / 100%;
        }
      }

      .nav-section-title {
        min-height: 48px;
        margin: 10px 22px 5px 38px;
        padding: 10px 12px 9px 14px;
        font-size: 17px;
        line-height: 24px;
      }

      .nav-item {
        position: relative;

        .icon-img {
          position: absolute;
          left: 12px;
          top: 17px;
        }

        .nav-item-link {
          display: block;
          height: 70px;
          line-height: 70px;
          padding-left: 58px;
          cursor: pointer;
          position: relative;

          span {
            font-size: 20px;
            color: #d4f9ff;
          }

          &::before {
            content: "";
            position: absolute;
            width: 40px;
            height: 40px;
            top: 14px;
            left: 16px;
            background: url("../../assets/img/menu-dot.png") no-repeat center / 100% 100%;
          }
        }
      }

      .active {

        a,
        .nav-item-link,
        .nav-group-title {
          color: #fff !important;
          background: url("../../assets/img/menu-select.png") no-repeat left center / 370px 130px;

          span {
            color: #fff !important;
          }
        }

        .nav-item-link {
          background: url("../../assets/img/menu-select.png") no-repeat left center / 370px 120px;
        }
      }
    }
  }

  .nav-icon {
    width: 40px;
    height: 70px;
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    left: 20px;

    &::before {
      content: "";
      display: block;
      width: 40px;
      height: 46px;
    }
  }
}
</style>
